import { useCallback, useEffect, useState } from 'react';
import { TOption } from '@src/types';
import { getCountries } from '@src/services/dropdown.ts';

export const useCountryOptions = () => {
  const [countryOptions, setCountryOptions] = useState<TOption[]>([]);

  const fetchCountryOptions = useCallback(async () => {
    const res = await getCountries();

    const options = res.data.map((item) => ({
      label: item.label,
      value: item.value,
    }));

    setCountryOptions(options);
  }, []);

  useEffect(() => {
    fetchCountryOptions().then();
  }, [fetchCountryOptions]);

  return { countryOptions, refresh: fetchCountryOptions };
};
